import { filterObject } from "@/utils/helpers";
import { useAxios } from "@/utils/hooks/useAxios";
import { useQuery } from "@tanstack/react-query";

export const useOrganizersAndContracts = (params = {}) => {
  const { axiosProtected } = useAxios();
  const filteredParams = filterObject(params);

  return useQuery({
    queryKey: ["organizers-and-contracts", filteredParams],
    queryFn: () =>
      axiosProtected.get("makkah/basic-packages", { params: filteredParams }),
  });
};
